import ObjectTypes from './object-types';
import scrollTo from './scrollTo';

export default {
  description: {
    type: ObjectTypes.String,
    warning: 'A description is required.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#profile-description'),
  },
  checkIn: {
    type: ObjectTypes.String,
    warning: 'A check in time is required.',
    progressValue: 1,
    only: ['accommodation'],
  },
  checkOut: {
    type: ObjectTypes.String,
    warning: 'A check out time is required.',
    progressValue: 1,
    only: ['accommodation'],
  },
  roomCountInfo: {
    type: ObjectTypes.roomCountInfo,
    warning: 'Room count is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#roomCount'),
  },
  bedsAndSofas: {
    type: ObjectTypes.BeddingConfig,
    warning: 'At least 1 bedding configuration is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#beddingConfig'),
  },
  // totalMaxPassengers: {
  //   type: ObjectTypes.totalMaxPassengers,
  //   warning: 'Total max passengers required.',
  //   progressValue: 1,
  //   only: ['nonAccommodation'],
  //   scrollTo: () => scrollTo.scrollToFunc('#passengers'),
  // },
  // totalMinPassengers: {
  //   type: ObjectTypes.totalMinPassengers,
  //   warning: 'Total minimum passengers required.',
  //   progressValue: 1,
  //   only: ['nonAccommodation'],
  //   scrollTo: () => scrollTo.scrollToFunc('#passengers'),
  // },
  tourDuration: {
    type: ObjectTypes.tourDuration,
    warning: 'Tour Duration is required or must not show Tour Duration.',
    progressValue: 1,
    only: ['nonAccommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#tourDuration'),
  },
  productInfo: {
    type: ObjectTypes.productInfo,
    warning: 'Product Information is required.',
    progressValue: 3,
    only: ['nonAccommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#product-info'),
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/product.js